export const emailIsRequired = value => (value ? undefined : 'Email Address is required')
export const nameIsRequired = value => (value ? undefined : 'Name is required')
export const usernameIsRequired = value => (value ? undefined : 'Username is required')



// WEBPACK FOOTER //
// ./src/smart-components/operator-form/validate.js